import Vue from "vue";
import VueI18n from "vue-i18n";
// 引入语言包
import zhCN from "./lang/zh-CN";
import en from "./lang/en";

// 注册 i18n 插件
Vue.use(VueI18n);

// 从本地存储获取默认语言（若没有则默认中文）
const defaultLang = localStorage.getItem("language") || "zh-CN";

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: defaultLang, // 当前语言标识（zh-CN / en）
  fallbackLocale: "zh-CN", // 语言包缺失时的默认语言
  messages: {
    "zh-CN": zhCN, // 中文语言包
    en: en // 英文语言包
  }
});

export default i18n;